import React, { FunctionComponent } from "react"
import Favicon from "react-favicon"
import { useAuth } from "../common/hooks/useAuth"
import clearFavicon from "../assets/clearFavicon.png"

export const BrandFavicon: FunctionComponent = () => {
    const { branding } = useAuth()
    const favicon = branding?.favicon
        ? "data:image/x-icon;base64," + branding.favicon
        : clearFavicon

    return <Favicon url={favicon} />
}
